<template>
  <div class="mx-auto">
    <v-card flat class="pa-5">
      <v-card-title class="pb-1">Informasi Laporan</v-card-title>
      <v-card-text>
        <v-list class="py-0">
          <v-list-item class="px-0">
            <v-list-item-content class="py-0">
              <v-row no-gutters>
                <v-col cols="12" md="4">
                  <v-label color="caption"><small>Jadwal Laporan</small></v-label>
                  <v-list-item class="px-0">
                    <v-list-item-avatar color="blue" class="mr-2">
                      <v-icon dark>mdi-calendar-month</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content class="py-0 px-1">
                      <div class="blue--text">
                        {{ $getDeepObj(initValue, 'jadwal') || '-' }}
                      </div>
                      <div class="black--text">
                        <b>Periode Laporan Berlaku</b>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" md="4">
                  <v-label color="caption"><small>Nama Sekolah</small></v-label>
                  <v-list-item class="px-0">
                    <v-list-item-avatar color="blue" class="mr-2">
                      <v-icon dark>mdi-office-building-outline</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content class="py-0 px-1">
                      <div class="blue--text">
                        {{ $getDeepObj(sekolah, 'sekolah.data.nama') || '-' }}
                      </div>
                      <div class="black--text">
                        <b>NPSN : </b>
                        {{ $getDeepObj(sekolah, 'sekolah.data.npsn') || '-' }}
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" md="4">
                  <v-label color="caption"><small>Nama Fasilitator</small></v-label>
                  <v-list-item class="px-0">
                    <v-list-item-avatar color="blue" class="mr-2">
                      <v-icon dark>mdi-account</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content class="py-0 px-1">
                      <div class="blue--text">
                        {{ $getDeepObj(initValue, 'ptk.nama') || '-' }}
                      </div>
                      <div class="black--text">
                        <b>No. UKG/SIMPKB ID : </b>
                        {{ $getDeepObj(initValue, 'ptk.no_ukg') || $getDeepObj(initValue, 'ptk.ptk_id') || '-' }}
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider class="my-3"></v-divider>
        <div v-if="instruments[kInstrumen]" class="black--text">
          <div class="mt-5">
            <div>
              <span
                class="font-weight-medium black--text"
                v-html="instruments[kInstrumen].label"
                style="font-size: 18px"
              ></span>
            </div>
            <span class="grey--text" v-html="instruments[kInstrumen].keterangan"></span>
          </div>
          <div>
            <v-expansion-panels accordion flat v-model="accordion">
              <v-expansion-panel v-for="(child, c) in instruments[kInstrumen].items" :key="c">
                <v-divider v-if="c > 0" />
                <v-expansion-panel-header class="px-0 py-2">
                  <v-row no-gutters>
                    <v-col cols="12" lg="8" class="my-auto">
                      <span class="subtitle-1 font-weight-regular"> {{ c + 1 }}. {{ child.keterangan }} </span>
                    </v-col>
                    <v-col cols="12" lg="4" class="text-right my-auto">
                      <v-btn
                        v-if="Number(form['jawaban'][child.k_kp_instrumen_psp]) !== 1"
                        color="success"
                        class="text-capitalize"
                        text
                        style="cursor: default"
                      >
                        <v-icon left small>mdi-check-circle-outline</v-icon> Tidak ada hambatan
                      </v-btn>
                      <v-btn
                        v-else-if="form['k_progres_psp'][child.k_kp_instrumen_psp] === 32"
                        color="warning"
                        class="text-capitalize"
                        text
                        style="cursor: default"
                      >
                        <v-icon left small>mdi-alert</v-icon> Butuh Dukungan
                      </v-btn>
                      <v-btn
                        v-else-if="form['k_progres_psp'][child.k_kp_instrumen_psp] === 30"
                        color="primary"
                        class="text-capitalize"
                        text
                        style="cursor: default"
                      >
                        <v-icon left small>mdi-circle-half-full</v-icon> Dalam Pengerjaan
                      </v-btn>
                      <v-btn
                        v-else-if="form['k_progres_psp'][child.k_kp_instrumen_psp] === 31"
                        color="success"
                        class="text-capitalize"
                        text
                        style="cursor: default"
                      >
                        <v-icon left small>mdi-check-circle-outline</v-icon> Selesai
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <template v-if="Number(form['jawaban'][child.k_kp_instrumen_psp]) !== 1">
                    <span class="grey--text">Tidak ada hambatan</span>
                  </template>
                  <template v-else>
                    <div class="font-weight-bold body-2 mb-1">Deskripsi Hambatan</div>
                    <v-alert text color="grey">
                      <span class="black--text">{{ form['deskripsi'][child.k_kp_instrumen_psp] }}</span>
                    </v-alert>
                    <div class="font-weight-bold body-2 mb-1 mt-7">Saran / Solusi</div>
                    <v-alert text color="grey">
                      <span class="black--text">{{ form['saran'][child.k_kp_instrumen_psp] }}</span>
                    </v-alert>
                    <template v-if="(tanggapanPmo[child.k_kp_instrumen_psp] || []).length">
                      <div class="font-weight-bold body-2 mb-1 mt-7">Tanggapan terhadap laporan</div>
                      <template v-for="(tanggapan, idx) in tanggapanPmo[child.k_kp_instrumen_psp] || []">
                        <v-alert
                          :key="idx"
                          colored-border
                          border="left"
                          :color="
                            WARNA_STATUS[tanggapan.k_progres_psp] && WARNA_STATUS[tanggapan.k_progres_psp]['color']
                          "
                          :style="{
                            backgroundColor:
                              WARNA_STATUS[tanggapan.k_progres_psp] &&
                              WARNA_STATUS[tanggapan.k_progres_psp]['background'],
                          }"
                        >
                          <v-row no-gutters>
                            <v-col
                              cols="12"
                              lg="8"
                              class="font-weight-medium"
                              :style="{
                                color:
                                  WARNA_STATUS[tanggapan.k_progres_psp] &&
                                  WARNA_STATUS[tanggapan.k_progres_psp]['color'],
                              }"
                            >
                              {{ $getDeepObj(tanggapan, 'instansi.data.nama') }}
                            </v-col>
                            <v-col cols="12" lg="4" class="text-right my-auto">
                              <v-icon left small class="grey--text" style="line-height: 1.5rem">mdi-calendar</v-icon>
                              <span class="body-2 grey--text" style="line-height: 1rem">
                                {{ $localDate(tanggapan.updated_at) }}
                              </span>
                            </v-col>
                          </v-row>
                          <v-divider class="my-2 mb-4 grey" style="opacity: 0.22"></v-divider>
                          <v-row no-gutters>
                            <v-col cols="12">
                              {{ tanggapan.catatan || '-' }}
                            </v-col>
                          </v-row>
                        </v-alert>
                      </template>
                    </template>
                    <template v-if="isAllowSelesai(child)">
                      <div class="font-weight-bold body-2 mt-7 my-auto">
                        Perbarui Status
                        <v-icon class="orange--text" small style="line-height: 1.5rem; font-size: 1.2rem">
                          mdi-alert
                        </v-icon>
                      </div>
                      <div>
                        Permasalahan Anda sudah diselesaikan oleh PMO Daerah / PMO Pusat. Silakan tutup laporan tersebut
                        dengan klik tombol <strong>Selesai</strong> di bawah.
                      </div>
                      <v-btn
                        :outlined="!(form.selesai || []).includes(child.k_kp_instrumen_psp)"
                        color="success"
                        class="text-capitalize mt-2"
                        dark
                        depressed
                        @click="onSetSelesai(child.k_kp_instrumen_psp)"
                      >
                        <v-icon left>mdi-check-circle-outline</v-icon> Selesai
                      </v-btn>
                    </template>
                  </template>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
  props: {
    initValue: {
      type: Object,
      default: null,
    },
    masters: {
      type: Object,
      default: () => {},
    },
    grup: {
      type: Object,
      default: () => {},
    },
    versi: {
      type: [Number, String],
      default: 1,
    },
    isPreview: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      accordion: null,
      form: {},
      sekolah: {},
      kInstrumen: '',
      tanggapanPmo: {},
      jenis: '',
      title: '',
      WARNA_STATUS: {
        32: { color: 'orange', background: '#FFF3E0', icon: 'mdi-check', catatanTeks: 'Catatan' },
        33: { color: 'primary', background: '#E1F5FE', icon: 'mdi-check', catatanTeks: 'Saran/Solusi' },
        34: {
          color: '#FF4A4A',
          background: '#FFF3E0',
          icon: 'mdi-close',
          catatanTeks: 'Catatan untuk Fasilitator Pelapor',
        },
        35: { color: '#FF7F2A', background: '#FFF3E0', icon: 'mdi-send', catatanTeks: 'Catatan untuk PMO Pusat' },
        36: { color: 'success', background: '#F1F8E9', icon: 'mdi-check', catatanTeks: 'Saran/Solusi' },
        37: { color: '#FF4A4A', background: '#FFEBEE', icon: 'mdi-close', catatanTeks: 'Catatan untuk PMO Dinas' },
      },
      durasis: [],
    };
  },
  computed: {
    instruments() {
      return {
        sdm: {
          label: 'A. Sumber Daya Manusia (SDM)',
          items: (this.grup && this.grup['sdm']) || [],
        },
        anggaran: {
          label: 'B. Anggaran',
          items: (this.grup && this.grup['anggaran']) || [],
        },
        teknologi: {
          label: 'C. Teknologi',
          items: (this.grup && this.grup['teknologi']) || [],
        },
        pembelajaran: {
          label: 'D. Kegiatan Pembelajaran',
          items: (this.grup && this.grup['pembelajaran']) || [],
        },
        pemda: {
          label: 'E. Dukungan Pemerintah Daerah',
          items: (this.grup && this.grup['pemda']) || [],
        },
        internal: {
          label: 'F. Dukungan Internal Sekolah',
          items: (this.grup && this.grup['internal']) || [],
        },
        mendesak: {
          label: 'G. Kondisi Mendesak',
          items: (this.grup && this.grup['mendesak']) || [],
        },
        lain: {
          label: 'H. Lainnya',
          items: (this.grup && this.grup['lain']) || [],
        },
      };
    },
  },
  methods: {
    ...mapActions('preferensi', ['cekRekaman']),
    ...mapActions('diklatPa', ['uploadBerkas', 'action']),

    reset() {
      this.form = {
        jawaban: {},
        k_progres_psp: {},
        deskripsi: {},
        saran: {},
        tanggapanPmo: {},
        k_belajar_psp: null,
        selesai: [],
      };
    },

    initForm(value) {
      if (!value) return;
      const { sekolah, formulir } = value;
      this.kInstrumen = value && value.grup;
      this.sekolah = sekolah;

      // set form
      this.$set(this.form, 'k_belajar_psp', formulir && formulir.k_belajar_psp ? `${formulir.k_belajar_psp}` : null);

      const keys = ['jawaban', 'k_progres_psp', 'deskripsi', 'saran'];
      const dataInstruments = this.$getDeepObj(formulir, 'psp_kp_pa_sekolah_instrumens.data') || [];
      const instruments = this.$arrToObj(dataInstruments, 'k_kp_instrumen_psp');

      if (this.instruments && this.instruments[this.kInstrumen] && this.instruments[this.kInstrumen]['items']) {
        for (const item of this.instruments[this.kInstrumen]['items']) {
          keys.forEach((key) => {
            const jawaban =
              instruments && instruments[item.k_kp_instrumen_psp] && instruments[item.k_kp_instrumen_psp][key];
            this.$set(
              this.form[key],
              item.k_kp_instrumen_psp,
              key === 'jawaban'
                ? jawaban === null || jawaban === undefined || isNaN(Number(jawaban))
                  ? ''
                  : Number(
                      instruments && instruments[item.k_kp_instrumen_psp] && instruments[item.k_kp_instrumen_psp][key]
                    )
                : key === 'k_progres_psp'
                ? Number(this.$getDeepObj(instruments, `${item.k_kp_instrumen_psp}.${key}`)) > 32
                  ? 30
                  : this.$getDeepObj(instruments, `${item.k_kp_instrumen_psp}.${key}`)
                : this.$getDeepObj(instruments, `${item.k_kp_instrumen_psp}.${key}`) || ''
            );
          });

          // check apakah memeiliki tanggapan dari pmo
          this.$set(
            this.tanggapanPmo,
            item.k_kp_instrumen_psp,
            this.$getDeepObj(instruments, `${item.k_kp_instrumen_psp}.psp_kp_pa_sekolah_instrumen_pmos.data`) || []
          );
        }
      }

      for (const id in this.instruments[this.kInstrumen].items || []) {
        const ins = this.instruments[this.kInstrumen].items[id];
        if (!this.accordion && this.isAllowSelesai(ins)) {
          this.accordion = +id;
        }
      }
    },

    isAllowSelesai(child) {
      const tanggapanPmo = [...[], ...(this.tanggapanPmo[child.k_kp_instrumen_psp] || [])].reverse();
      const tanggapanAkhir = (tanggapanPmo && tanggapanPmo[0]) || {};

      return (
        ![37].includes(tanggapanAkhir.k_progres_psp) && this.form['k_progres_psp'][child.k_kp_instrumen_psp] !== 31
      );
    },

    getValue() {
      return {
        grup: this.kInstrumen,
        k_kp_instrumen_psp: this.form.selesai || [],
      };
    },

    validate() {
      return true;
    },

    onSetSelesai(kKpInstrumenPsp) {
      const index = this.form.selesai.indexOf(kKpInstrumenPsp);
      if (index > -1) {
        this.form.selesai.splice(index, 1);
      } else {
        this.form.selesai.push(kKpInstrumenPsp);
      }
    },
  },
  watch: {
    initValue: 'initForm',
  },
};
</script>
